export const ReportOptions = Object.freeze({
  DOWNLOAD_ATTACHMENT_NAME: 'downloadAttachmentName',
  MAX_LIMIT: 2000,
});
